import { gql } from "graphql-request";

import type { ItemsQuery } from "@mondaydotcomorg/api";
import { OPERATION_COLUMNS } from "@onesolution/constants";
import type { Context } from "@onesolution/middlewares";
import {
	ALL_MONDAY_SCHEMAS,
	MONDAY_PAGINATED_PARAMS_DEF,
	MONDAY_PAGINATED_PARAMS_USE,
	type MONDAY_TYPES,
} from "@onesolution/monday";
import type { DefaultPaginatedQueryParams } from "../defaultPaginatedParams";
import { formatPaginatedResult } from "../format";
import { requestAndFormat } from "../utils";

type OperationBaseList = Array<
	MONDAY_TYPES["base"] & {
		status: MONDAY_TYPES["status"];
		timeline: MONDAY_TYPES["text"];
		products: { linked_item_ids: string[] };
	}
>;

export const operationPlanningBaseQuery = (
	context: Context,
	params?: DefaultPaginatedQueryParams & { queryParams: ItemsQuery },
) =>
	requestAndFormat(
		{
			defaultParams: {
				boardId: context.boards?.briefs,
				columnIds: [
					OPERATION_COLUMNS.name,
					OPERATION_COLUMNS.timeline,
					OPERATION_COLUMNS.status,
					OPERATION_COLUMNS.products,
				],
			},
			gql: gql`
                query GetOperationPlanningBaseQuery(
					$boardId: ID!,
					$columnIds: [String!],
					${MONDAY_PAGINATED_PARAMS_DEF(params?.cursor, "$queryParams: ItemsQuery")}
				) {
                    boards(ids: [$boardId]) {
                        id
                        items_count
                        name
                        items_page(
							${MONDAY_PAGINATED_PARAMS_USE(params?.cursor, "query_params: $queryParams")}
						) {
                            cursor
                            items {
                                id
                                name        
                                column_values(ids: $columnIds) {
                                    ${ALL_MONDAY_SCHEMAS}
                                    
                                    ... on BoardRelationValue {
                                        linked_item_ids
                                    }
                                }
                            }
                        }
                    }
                }`,
			resultKey: "boards[0].items_page.items",
			additionalFormatting: formatPaginatedResult<OperationBaseList[number]>(
				"boards[0].items_page.cursor",
			),
			outType: {} as {
				cursor: string;
				items: OperationBaseList;
			},
		},
		params,
	);
